import { defaultTheme, themes } from "design-system/themeContext";
import { getTenantConfig } from "features/white-labeling/lib/tenantConfig";

const applyTenantUrls = (theme, tenantConfig) => {
  if (!tenantConfig?.websiteUrl) return theme;

  return {
    ...theme,
    links: {
      ...theme.links,
      website: tenantConfig.websiteUrl,
    },
    logo: {
      ...theme.logo,
      href: tenantConfig.websiteUrl,
    },
  };
};

export const getActiveTheme = () => {
  const tenantConfig = getTenantConfig();
  const themeKey = tenantConfig?.theme;
  const baseTheme = themeKey ? themes[themeKey] : undefined;

  if (!baseTheme) return null;

  return applyTenantUrls(baseTheme, tenantConfig);
};

export const getIsDefaultTheme = (themeName) => {
  return themeName === defaultTheme.name;
};
